import React, { useEffect, useRef, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Chartplotter from "@/components/sections/Chartplotter";
import AllBoats from "@/components/sections/AllBoats";
import ServiceMap from "@/components/sections/ServiceMap";
import Process from "@/components/sections/Process";
import Configurator from "@/components/sections/Configurator";
import Certifications from "@/components/sections/Certifications";
import Portfolio from "@/components/sections/Portfolio";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

function SonarPing() {
  const [ping, setPing] = useState(0);
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) setPing((p) => p + 1); }),
      { threshold: 0.35 }
    );
    document.querySelectorAll("section[id]").forEach((s) => obs.observe(s));
    return () => obs.disconnect();
  }, []);
  return (
    <div className="fixed inset-0 z-[400] pointer-events-none grid place-items-center" data-testid="sonar-ping">
      <span key={ping} className="block w-40 h-40 rounded-full border border-cyan/40"
        style={{ animation: ping ? "ping-ring 1.1s ease-out" : "none" }} />
    </div>
  );
}

function Site() {
  const { theme } = useApp();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className={`App noise-overlay min-h-screen ${theme === "dark" ? "dark" : ""}`}>
      <SonarPing />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Chartplotter />
        <AllBoats />
        <ServiceMap />
        <Process />
        <Certifications />
        <Configurator />
        <Portfolio />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme={theme} toastOptions={{ style: { fontFamily: "JetBrains Mono, monospace" } }} />
    </div>
  );
}

export default function App() {
  return (
    <AppProvider>
      <Site />
    </AppProvider>
  );
}
